<!--店铺管理-->
<template>
  <div  class="app-container">
    <!--    查询条件区域-->
    <!-- <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="120px">
          <el-form-item label="卡名称:">
            <el-input v-model="queryParam.name" placeholder="输入卡名称"></el-input>
          </el-form-item>
          <el-form-item label="消费类型:">
            <el-select v-model="queryParam.expType" placeholder="请选择">
              <el-option
                v-for="item in optionsExpType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
        <el-button type="primary" size="medium" class="operator-btn" style="margin-top: 5px" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card> -->
    <!--    查询结果区域-->
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="warning" class="operator-btn2" icon="el-icon-circle-plus-outline" @click="handleCreateOneShowDlg()">添加子类型</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData"
                style="width: 100%"
                :data="tableData"
                max-height="520"
                v-loading="listLoading" border
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="number" label="序号"></el-table-column>
        <el-table-column prop="name" label="子类型名称" ></el-table-column>
        <el-table-column prop="storeLessonIdDes" label="版本" ></el-table-column>
        <el-table-column prop="ratio" label="比例" ></el-table-column>
      </el-table>
    </div>
    <!-- <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div> -->
    <!--    添加子类型-->
    <el-dialog
      title="添加子类型"
      :visible.sync="visibleDlgAdd"
      width="50%"
      top="8vh"
      center>
      <NewStoreLessonCardInfo ref="AddNewVIPCard" :store-lessons="storeLessons" :is-exp="0" :key="timeRefresh"></NewStoreLessonCardInfo>
      <div slot="footer" class="dialog-footer-1">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="primary" @click="handleCreateOne('AddNewVIPCard')">保存</el-button>
      </div>
    </el-dialog>
    <worker-word :key="refreshWord" :word-type="wordType" :t-data="tData" :show = "showWordDlg" @onWorkerWord="handleWord"></worker-word>
  </div>
</template>

<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
</style>

<script>
  import {
    getCardSubTypeList,
    forbitLessonCard,
    newCardSubType,
    useLessonCard
  } from "../../api/StoreLessonCard";
  import globaldata from "../../utils/globaldata";
  import commonUtils from "../../utils/commonUtils";
  import messageUtils from "../../utils/messageUtils";
  import WorkerWord from "../../components/WorkerWord/WorkerWord";
  import NewStoreLessonCardInfo from "./components/NewStoreLessonCardInfo";
  import enumsUtil, {ECardExpType, ECardUseType, getEnumDesByV} from "../../utils/enumsUtil";

  export default {
    components:{NewStoreLessonCardInfo, WorkerWord},
    data() {
      return {
        listLoading: true,
        visibleDlgAdd:false,
        visibleDlgAddExpCard:false,
        visibleDlgForbit:false,
        timeRefresh:"",
        isExp:-1,

        refreshWord:"",
        showWordDlg:false,
        tData:null,
        wordType : 0,
        queryParam:{
          name: '',
          expType:0,

          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },
        optionsExpType:[
          {
            value:0,
            label:"VIP卡",
          },
          {
            value:1,
            label:"体验卡",
          },
        ],

        cooperationDate:'' ,//合作时间
        multipleSelection: [], //选择的表单
        //表单结果
        tableData: [
        ],

        forbitParam:{
          id :'',
          name :''
        },

        //编辑店铺信息
        editStoreInfo :{

        },
        //店铺可以使用的课程
        storeLessons:"",

        createParam :{

        },

        rules:{
          name:[{required:true,message:"请输入子类型名称",trigger:"blur"}],
          storeLessonCardTemplateId:[{required:true,message:"请选择业务类型",trigger:"blur"}],
          ratio:[{required:true,message:"请输入比例",trigger:"blur"}],
        },

      }
    },
    created(){

      globaldata.getStoreLessonTemplate(this.getStoreLessonTemplate);
      this.initParam();
    },
    mounted() {

    },
    methods: {

      initParam(){
        this.createParam = {
          name: '',
          storeLessonCardTemplateId:'',
          storeFrontId:'',
          ratio:1,
        }
      },
      getStoreLessonTemplate(data){
        this.storeLessons =data;
        this.flechList();
      },
      flechList(){

        this.listLoading = true;
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId,
        }
        getCardSubTypeList(param).then(response =>
          {
            this.listLoading = false;
            let data = response.data;
            if (commonUtils.isObjectNull(data)){
              return;
            }
            this.refreshData(data);

          })
      },
      //刷新页面数据
      refreshData(list){
        if (commonUtils.isObjectNull(list)){
          return;
        }
        let tableDataList = [];
        for (let i = 0;i< list.length;++i){
          let storeLessonIdDes = this.getstoreLesson(list[i].storeLessonCardTemplateId).type;
          let data = {
            number : i+1 ,
            id: list[i].id,
            name: list[i].name,
            storeLessonCardTemplateId:list[i].storeLessonCardTemplateId,
            ratio:list[i].ratio,
            storeLessonIdDes:storeLessonIdDes,
          };
          tableDataList.push(data);
        }

        this.tableData = tableDataList;
      },
      //点击查询按钮
      onBtnSearch(){
        this.flechList();
      },

      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.flechList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
      },

      //禁用
      handleForbitOne(row){
        let  tData = {
          cardId :row.id,
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          adminId:globaldata.getAdminStore().id
        }
        this.doRefreshWord(true,2,tData);
      },
      handleForbit(param){
        forbitLessonCard(param).then(response =>
        {
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          messageUtils.successMsg(this,response.message);
          this.flechList();
          this.closeWordDlg();
        })
      },

      handleUseOne(row){
        let tData = {
          cardId:row.id,
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          adminId:globaldata.getAdminStore().id
        }
        this.doRefreshWord(true,3,tData);
      },
      handleUse(param){
        useLessonCard(param).then(response =>
        {
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          messageUtils.successMsg(this,response.message);
          this.flechList();
          this.closeWordDlg();
        })
      },


      handleCreateOneShowDlg(){
        this.initParam();
        this.visibleDlgAdd = true;
      },
      handleCreateExpCardShowDlg(){

        this.timeRefresh = new Date().getTime();
        this.visibleDlgAddExpCard = true;
      },
      getstoreLesson(lessonTemplateId){
        for (let i = 0;i<this.storeLessons.length;++i){
          if (this.storeLessons[i].id == lessonTemplateId) {
            return this.storeLessons[i];
          }
        }
      },
      //添加

      showWordDlgCreate(){
        let storeLessonId = this.getstoreLesson(this.createParam.optionsLessonValue).storeLessonId;
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          name: this.createParam.name,
          descripe: this.createParam.descripe,
          storeLessonCardTemplateId:this.createParam.optionsLessonValue,
          storeLessonId:storeLessonId,
          validDays: this.createParam.validDays,
          totalClassCount:this.createParam.totalClassCount,
          giveClassCount:this.createParam.giveClassCount,
          valueMoney:this.createParam.valueMoney,
          createAdminId :globaldata.getAdminStore().id,
          consumeType:this.createParam.optionsValue,
          statu :this.createParam.optionsUseValue,
          points:this.createParam.points,
          useType :this.createParam.useType,
          adminWord:"",

        }
        this.tData = param;
        this.doRefreshWord(true,1);
      },

      doCareateOne(param){
        newCardSubType(param).then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            messageUtils.errorMsg(this,"创建失败")
            return;
          }
          this.onCreateSuccess();
        })
      },
      onCreateSuccess(){
        messageUtils.successMsg(this,"创建成功");
        this.visibleDlgAdd = false;
        this.visibleDlgAddExpCard = false;
        this.closeWordDlg();
        this.flechList();
      },

      handleCreateOne(ref){
        this.$refs[ref].getCardInfo(this.onGetCardInfo);
      },

      onGetCardInfo(info){

        if (commonUtils.isObjectNull(info) || info == false){
          return;
        }
        this.doRefreshWord(true,1,info);
      },

      handleWord(wordType,tData){

        //添加
        if (wordType == 1){
          this.doCareateOne(tData)

        }else if (wordType == 2){
          //禁用
          this.handleForbit(tData)

        } else if (wordType == 3){
          //启用
          this.handleUse(tData)
        }
      },
      doRefreshWord(show,wordType,tData){
        this.wordType = wordType;
        this.tData = tData;
        this.refreshWord = new Date().getTime();
        this.showWordDlg = show;
      },
      closeWordDlg(){
        this.wordType = 0;
        this.refreshWord = new Date().getTime();
        this.showWordDlg = false;
      }


    }
  }
</script>






// WEBPACK FOOTER //
// src/views/store-lesson-card-sub-type/index.vue